import { Component, Input, inject, ChangeDetectionStrategy, signal, computed } from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'
import { FormulaRenderService } from '@monorepo/angular-common'
import { Content } from '@monorepo/golab-generated'
import { containsFormula } from '@monorepo/utils'

@Component({
  selector: 'app-text-content',
  templateUrl: './text-content.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./text-content.component.scss'],
})
export class TextContentComponent {
  private readonly DomSanitizer = inject(DomSanitizer);
  private readonly formulaRenderService = inject(FormulaRenderService)

  private readonly html = signal('')
  private readonly formulasLoaded = signal(this.formulaRenderService.isLoaded)

  /** Formulas show their plain text until KaTeX is loaded, and are drawn after that. */
  readonly htmlToShow = computed(() => {
    this.formulasLoaded()
    return this.DomSanitizer.bypassSecurityTrustHtml(this.formulaRenderService.renderFormulasInHtml(this.html()))
  })

  @Input() set content(content: Content | undefined) {
    const html = content?.html ? content.html : ''
    this.html.set(html)
    if (containsFormula(html) && !this.formulaRenderService.isLoaded) {
      this.formulaRenderService.load().then(
        () => this.formulasLoaded.set(true),
        () => undefined, // the formulas keep showing their plain text
      )
    }
  }
}
